export const availableRoutesList = [
  'applicationPage1',
  'applicationPage2',
  'applicationPage3',
  'applicationPage4',
  'applicationPage5',
  'loading',
  'offer',
  'thank-you',
  'credit-frozen',
  'ineligible',
  'pending',
]

export const organicFlowRoutesList = [
  'applicationPage1',
  'applicationPage2',
  'applicationPage3',
  'applicationPage4',
  'applicationPage5',
  'loading',
  'offer',
  'thank-you',
]

export const landingRoutes = ['applicationPage1', 'error']

export const applicationCompleteRoutes = ['loading', 'offer', 'thank-you']
